"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyOwnerQuoteDetails = exports.emptyOwnerDetails = exports.OwnerDetailsQuotePropType = exports.OwnerDetailsPropType = void 0;
require("core-js/modules/es.symbol.description.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const OwnerDetailsPropType = exports.OwnerDetailsPropType = {
  name: _propTypes.default.string,
  email: _propTypes.default.string.isRequired,
  birthdate: _propTypes.default.string,
  postcode: _propTypes.default.string
};
const OwnerDetailsQuotePropType = exports.OwnerDetailsQuotePropType = _objectSpread(_objectSpread({}, OwnerDetailsPropType), {}, {
  promoCode: _propTypes.default.string,
  membership: _propTypes.default.string
});
const emptyOwnerDetails = exports.emptyOwnerDetails = {
  name: '',
  birthdate: '',
  email: '',
  postcode: ''
};
const emptyOwnerQuoteDetails = exports.emptyOwnerQuoteDetails = _objectSpread(_objectSpread({}, emptyOwnerDetails), {}, {
  membership: '',
  promoCode: ''
});